<template>
    <div class="row">
        <div class="position-relative w-100 p-2">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <patient-overview :patient="patient"></patient-overview>
                    <patient-alerts :patient="patient"></patient-alerts>
                </div>
                <div class="col-12 col-lg-6">
                    <patient-assessment></patient-assessment>
                    <patient-updates></patient-updates>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PatientOverview from "./PatientOverview";
import PatientAssessment from "./PatientAssessment";
import PatientAlerts from "./PatientAlerts";
import PatientUpdates from "./PatientUpdates";

export default {
    name: "Overview",
    props: ["patient"],
    components: {
        PatientOverview,
        PatientAssessment,
        PatientAlerts,
        PatientUpdates,
    },
};
</script>

<style scoped lang="scss"></style>
